import "./footer.css"
import { IconContext } from "react-icons";
import { FaInstagram,FaFacebook,FaWhatsapp} from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';

const Footer = () => {

    const {t} = useTranslation();//Tomis, si ves esto, acá se guardan los datos del json que contiene la traducción
    return (
        <footer>
            <div className="cajaContenido">
                    <div className="logo">
                        <img src="/img/Logo.webp" alt="logo de Nazaréen"/>
                        <div className="nombreLema">
                        <h3>{t('Footer.nombre')}<br/>{t('Footer.nombre2')}</h3>
                        <p>{t('Footer.lema')}</p>
                        </div>
                    </div>
                    <div className="separador"></div>
                    <div className="redesUbi">
                        <IconContext.Provider value={{className: "iconos"}}>
                        <p><FaInstagram/><a href="https://www.instagram.com/masajes.ushuaia.almalibre?igsh=MWp1dmlmYXZteTEzOQ==">Instagram</a></p>
                        <p><FaFacebook/><a href="https://wa.me/5492901508935?text=Hola%2C%20quiero%20más%20información%20sobre%20tus%20servicios">Facebook</a></p>
                        <p><FaWhatsapp/><a href="https://wa.me/5492901508935?text=Hola%2C%20quiero%20más%20información%20sobre%20tus%20servicios">WhatsApp</a></p>
                        <p><FaMapLocation/>{t('Footer.localización')}</p>
                        </IconContext.Provider>
                    </div>
                </div>
    <p className="copy">{t('Footer.copyright')}</p>
        </footer>
    );
}

export default Footer;